import React, {useEffect} from 'react';
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import s from './CustomDropdown.module.css'
import './index.css'
import {useTranslation} from "react-i18next";

const App: React.FC = () => {

    // @ts-ignore
    const { i18n } = useTranslation();

    const [selectedLang, setSelectedLang] = React.useState<string>("english");

    useEffect(() => {
        const currentLng = localStorage.getItem("i18nextLng")
        if ( currentLng === "en" ) {
            setSelectedLang("english")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "ru" ) {
            setSelectedLang("русский")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "es" ) {
            setSelectedLang("español")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "tr" ) {
            setSelectedLang("türkçe")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "fr" ) {
            setSelectedLang("français")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "de" ) {
            setSelectedLang("Deutsch")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "zh" ) {
            setSelectedLang("中文 (Zhōngwén)")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "ja" ) {
            setSelectedLang("日本語 (Nihongo)")
            i18n.changeLanguage(currentLng)
        } else if ( currentLng === "ko" ) {
            setSelectedLang("한국어")
            i18n.changeLanguage(currentLng)
        } else {
            setSelectedLang("english")
            i18n.changeLanguage("en")
        }
    }, [])

    const onItemHandleClick = (lngObj: {language: string, short: string} ) => {
        setSelectedLang(lngObj.language)
        i18n.changeLanguage(lngObj.short)
    }

    const items: MenuProps['items'] = [
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "english", short: "en"})}>
                    English
                </div>
            ),
            key: '0',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "русский", short: "ru"})}>
                    Русский
                </div>
            ),
            key: '1',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "español", short: "es"})}>
                    Español
                </div>
            ),
            key: '2',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "türkçe", short: "tr"})}>
                    Türkçe
                </div>
            ),
            key: '3',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "français", short: "fr"})}>
                    Français
                </div>
            ),
            key: '4',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "Deutsch", short: "de"})}>
                    Deutsch
                </div>
            ),
            key: '5',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "中文 (Zhōngwén)", short: "zh"})}>
                    中文 (Zhōngwén)
                </div>
            ),
            key: '6',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "日本語 (Nihongo)", short: "ja"})}>
                    日本語 (Nihongo)
                </div>
            ),
            key: '7',
        },
        {
            label: (
                <div onClick={() => onItemHandleClick({language: "한국어", short: "ko"})}>
                    한국어
                </div>
            ),
            key: '8',
        },
    ];

    return (
        <Dropdown menu={{ items }} trigger={['click']} className={s.dropdown_wrapper}>
            <a onClick={(e) => e.preventDefault()} className={s.button}>
                <Space>
                    {selectedLang}
                    <DownOutlined />
                </Space>
            </a>
        </Dropdown>
    );
}



export default App;
